import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { SEO } from "@qgiv/core-donor";
import P2PRegistrationBase from "../templates/P2PRegistrationBase";
import ReceiptPageContainer from "../../Containers/ReceiptPageContainer";
import ConnectedReceiptMessage from "./ConnectedReceiptMessage";

import "./ReceiptPage.scss";

const ReceiptPage = ({
    containers = [],
    currentPage,
    documentTitle = "",
    receiptDefaultView,
    updateCurrentPage = () => {},
}) => {
    useEffect(() => {
        if (currentPage !== receiptDefaultView) {
            updateCurrentPage(receiptDefaultView);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);
    return (
        <P2PRegistrationBase>
            <SEO title={documentTitle} description="" />
            <div className="receipt-page">
                <ConnectedReceiptMessage />
                <ReceiptPageContainer containers={containers} />
            </div>
        </P2PRegistrationBase>
    );
};

ReceiptPage.propTypes = {
    documentTitle: PropTypes.string.isRequired,
    containers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    currentPage: PropTypes.number.isRequired,
    receiptDefaultView: PropTypes.number.isRequired,
    updateCurrentPage: PropTypes.func.isRequired,
};

export default ReceiptPage;
